import "./ProjectItem.css"


export type item = {
    title: string,
    desc: string
    logo: string
    goto:string
}
export default function ProjectItem(props : item){
    return(
        <div className="project-item w-[40vh] relative" id="projects">
            <div className="subtitle text-xl -ml-1 p-3 hover:bg-green-400 duration-300 ">
               <img className="pr-3" src={props.logo}/> {props.title}
            </div>
            <div className="item-desc p-4">
                    {props.desc}
            </div>
            
            <div className="readmore p-4 absolute">
                <p className="mt-5 text-orange-500 underline"><a href={props.goto}>Read more ➜</a></p>
            </div>
        </div>
    )
}